/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded'
import { Button, Chip, TextField } from '@mui/material'
import clsx from 'clsx'
import { generateRandomGuiID } from '../../utils/commonUtils'
import { ChipFieldProps } from './_props/ChipFieldProps'
import useStyles from './_styles/ChipFieldStyles'
import TokTokDocDialog from './Dialog'
import { cleanAccentsAndDiacritics } from '../../utils/stringUtils'

const ChipField = ({
    values,
    onChange,
    dialogTitle,
    dialogSubtitle,
    onDelete,
    disabled,
    dataCy,
    hasError,
    placeholder = 'Cliquer pour ajouter',
    textFieldValueStyle,
}: ChipFieldProps) => {
    const classes = useStyles()
    const [isDialogOpen, setIsDialogOpen] = React.useState(false)
    const [newName, setNewName] = React.useState<string | undefined>()

    const nameAlreadyTaked = values?.includes(newName)

    const handleCancel = () => {
        setNewName(undefined)
        setIsDialogOpen(false)
    }

    const handleValidate = () => {
        if (newName && newName.trim().length > 0) {
            onChange(newName)
            setIsDialogOpen(false)
            setNewName(undefined)
        }
    }

    return (
        <>
            <div
                className={clsx(classes.ChipFieldWrapper, hasError && classes.ChipFieldWrapperError)}
                onClick={() => setIsDialogOpen(true)}
                data-cy={dataCy}
            >
                <div className={classes.ChipField}>
                    {values?.map((value, index) => {
                        const key = generateRandomGuiID()
                        return (
                            <Chip
                                key={key}
                                data-tag-index={index}
                                tabIndex={-1}
                                label={value}
                                deleteIcon={<HighlightOffRoundedIcon />}
                                onDelete={() => (value ? onDelete(value) : undefined)}
                                disabled={disabled}
                            />
                        )
                    })}
                    {!values || values.length === 0 ? (
                        <span className={clsx(classes.ChipFieldWrapperPlaceholder)}>{placeholder}</span>
                    ) : (
                        ''
                    )}
                </div>

                {!disabled && (
                    <Button
                        variant="contained"
                        color="inherit"
                        disableElevation
                        className={classes.ChipFieldAddButton}
                        onClick={() => setIsDialogOpen(true)}
                    >
                        <AddRoundedIcon />
                    </Button>
                )}
            </div>

            {!disabled && (
                <TokTokDocDialog
                    isOpen={isDialogOpen}
                    handleClose={handleCancel}
                    title={dialogTitle}
                    subtitle={dialogSubtitle}
                    handleSave={handleValidate}
                    saveTitle="Valider"
                    saveButtonCy={`${dataCy}-saveButton`}
                    disableCondition={!newName || newName.trim().length === 0 || nameAlreadyTaked}
                >
                    <TextField
                        variant="outlined"
                        autoFocus
                        autoComplete="none"
                        className={classes.ChipFieldTextField}
                        value={newName || ''}
                        placeholder="Tapez le prénom à ajouter"
                        error={nameAlreadyTaked}
                        helperText={nameAlreadyTaked ? 'Ce prénom est déja présent dans la liste' : undefined}
                        onChange={(e) => {
                            if (textFieldValueStyle === 'uppercase') {
                                const cleanValue = cleanAccentsAndDiacritics(e.target.value).toUpperCase()
                                setNewName(cleanValue)
                            } else {
                                setNewName(e.target.value)
                            }
                        }}
                        data-cy={`${dataCy}-input`}
                        onKeyUp={(key) => {
                            if (key.code.toLocaleLowerCase() === 'enter') {
                                handleValidate()
                            }
                        }}
                    />
                </TokTokDocDialog>
            )}
        </>
    )
}

export default ChipField
